module.exports = {
    API_ENDPOINT: `https://quiet-stream-59097.herokuapp.com/api`,
    //API_ENDPOINT: 'http://localhost:8000/api' //development
  }
  